
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { PriceSourceSource } from '@/Sources';
import { IPriceSource } from '../../Interfaces';

  @Component({
    name: 'price-source-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class PriceSourceDropdownField extends Vue {
    @Prop() public value!: IPriceSource;
    @Prop({ default: 'Price Source' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ type: Boolean, default: false }) public required!: boolean;
    @Prop() public valueField!: string | undefined;

    public source: PriceSourceSource = new PriceSourceSource();

    public get val(): IPriceSource { return this.value; }
    public set val(value: IPriceSource) {
      this.$emit('input', value);
    }
  }
